import * as React from 'react';
const SvgStar = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.803 15.4L8 12.847l4.197 2.553a.65.65 0 00.97-.705l-1.13-4.78 3.724-3.203a.65.65 0 00-.37-1.14l-4.896-.403L8.6.637a.65.65 0 00-1.2 0L5.505 5.17.61 5.571a.65.65 0 00-.37 1.14l3.724 3.203-1.13 4.78a.65.65 0 00.97.706zm4.717-4.227a1 1 0 00-1.04 0l-2.415 1.47.65-2.752a1 1 0 00-.32-.988L3.25 7.06l2.818-.23a1 1 0 00.84-.612L8 3.61l1.09 2.61a1 1 0 00.841.61l2.818.231-2.144 1.843a1 1 0 00-.32.988l.65 2.751-2.415-1.469z"
            fill="currentColor"
        />
    </svg>
);
export default SvgStar;
